// extracted by mini-css-extract-plugin
export default {"templateBtn":"TemplateGeneration_templateBtn__z7GHs","title":"TemplateGeneration_title__LkTVj","small":"TemplateGeneration_small__8gAD1"};